import { ReactElement, ReactNode } from 'react';
import { Theme } from '@emotion/react';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SxProps } from '@mui/material/styles';

import './overflow-menu.scss';

export type OverflowMenuItem =
  | {
      label: string;
      startIcon?: ReactElement;
      sx?: SxProps<Theme>;
      action: () => void;
      disabled: boolean;
    }
  | 'divider';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  anchorEl?: null | Element | (() => Element);
  menuItems: Array<OverflowMenuItem>;
};

const OverflowMenu = ({ isOpen, onClose, anchorEl, menuItems }: Readonly<Props>): React.JSX.Element => {
  const mapMenuItems = (): ReactNode => {
    return menuItems.map((item, index) => mapMenuItem(item, `menu-item-${index}`));
  };

  const mapMenuItem = (item: OverflowMenuItem, key: string): ReactNode => {
    return item === 'divider' ? (
      <Divider key={key} />
    ) : (
      <MenuItem
        data-testid={`overflow-menu-item-${key}`}
        key={key}
        onClick={item.action}
        className="menu-item"
        disabled={item.disabled}
        sx={item.sx}
      >
        {item.startIcon}
        {item.label}
      </MenuItem>
    );
  };

  return (
    <Menu
      onClose={onClose}
      anchorEl={anchorEl}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isOpen}
      onClick={onClose}
      className="overflow-menu-paper"
    >
      {mapMenuItems()}
    </Menu>
  );
};

export default OverflowMenu;
